// import store from '@/state/store'
import guestMiddleware from './../middleware/guestMiddleware';
import isSacrificialMiddleware from '../middleware/isSacrificialMiddleware'

export default [
  {
    path: '/',
    name: 'default',
    component: () => import('./views/home/index'),
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/home/index',
    name: 'index',
    component: () => import('./views/home/index')
  },
  {
    path: '/martyr-code',
    name: 'martyr-code',
    component: () => import('./views/home/martyr-code')
  },
  {
    path: '/qr-info/:code(\\d{10})',
    name: 'qr-info',
    component: () => import('./views/home/qr-info')
  },
  {
    path: '/bank-loans/martyr/:code(\\d{10})',
    name: 'bank-loans.martyr',
    component: () => import('./views/bank-loans/martyr'),
    beforeEnter:isSacrificialMiddleware
  },
  {
    path: '/bank-loans/injured',
    name: 'bank-loans.injured',
    component: () => import('./views/bank-loans/injured')
  },
  {
    path: '/plots-of-land/martyr/:code(\\d{10})',
    name: 'plots-of-land.martyr',
    component: () => import('./views/plots-of-land/martyr'),
    beforeEnter:isSacrificialMiddleware
  },
  {
    path: '/plots-of-land/injured',
    name: 'plots-of-land.injured',
    component: () => import('./views/plots-of-land/injured')
  },
  {
    path: '/alhaj',
    name: 'pilgrimage',
    component: () => import('./views/pilgrimages/pilgrimage'),
    meta: {
      middleware: ['authMiddleware'],
    },
  },
  {
    path: '/home/mrs-world',
    name: 'mrs-world',
    component: () => import('./views/home/mrs-world')
  },
  {
    path: '/projects-exhibition/projects',
    name: 'projects-exhibition.projects',
    component: () => import('./views/projects-exhibition/projects')
  },
  {
    path: '/alhaj/login',
    name: 'pilgrimage.login',
    component: () => import('./views/pilgrimages/account/login'),
    beforeEnter: guestMiddleware
  },
]
